import React, { useEffect, useState } from 'react'
import { CustomerServiceFilled, DownOutlined, MenuOutlined } from '@ant-design/icons';
import { UserOutlined } from '@ant-design/icons';
import logo from '../../../assets/logo.png';
import trainTicket from '../../../assets/train-ticket.png';
import busTicket from '../../../assets/bus-ticket.png';
import { Badge, Dropdown } from 'antd';

import backgroundImage from '../../../assets/nav-bg-1.png'
import { Menu, Button } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';



function Mynav() {


  const location = useLocation();

  const navigate = useNavigate(); // Get the navigate function from the hook
  const [isloggedin, setIsloggedin] = useState(null)



  useEffect(() => {

    console.log('useeffect activated')
    setIsloggedin(localStorage.getItem('userdatatoken'))
  }, [location.pathname])







  const menuItems = [
    {
      key: 1,
      routes: 'profile',
      name: 'My Profile',
    },
    {
      key: 2,
      isSeparator: true,
    },
    {
      key: 3,
      routes: 'ticket',
      name: 'Show My Ticket',
    },
    {
      key: 4,
      isSeparator: true,
    },
    {
      key: 5,
      routes: 'trips',
      name: 'My Trips',
      state: { fromNavbar: true },
    },
    {
      key: 6,
      routes: 'wallet',
      name: 'My Wallet',
    },
    {
      key: 7,
      isSeparator: true,
    },
    {
      key: 8,
      routes: 'help',
      name: 'HELP',
      isMob: true,
    },
    {
      key: 9,
      routes: '/',
      name: 'Bus_Ticket',
      isMob: true,
    },
    {
      key: 10,
      routes: '/train',
      name: 'Train Ticket',
      isMob: true,
    },
    {
      key: 11,
      isSeparator: true,
      isMob: true,
    },
    {
      key: 12,
      name: isloggedin ? 'Logout' : 'Login',
      routes: '/auth',
    },
  ];
  

  const MenuSeparator = () => (
    <Menu.Divider />
  );






  // logic for the LOGOUT


const handleLogout = () => {
  console.log('Logout called');
  localStorage.removeItem('userdatatoken');
  localStorage.removeItem('username');
  navigate('/home')
};

  const MobMenu = (
    <Menu>
      {menuItems.map(item => (
        item.isMob ? null :
          item.isSeparator ? (
            <MenuSeparator key={item.key} /> 
          ) : (
            item.name === 'Logout' ? (
              <Menu.Item key={item.key} className='menu' onClick={handleLogout}>
                {item.name}
              </Menu.Item>
            ) : (
              <Menu.Item key={item.key} className='menu'>
                <Link to={item.routes} className='menu-item'>{item.name}</Link>
              </Menu.Item>
            )
          )
      ))}
    </Menu>
  );




  const menu = (
    <Menu>
      {menuItems.map(item => (
        item.isMob ? null :
          item.isSeparator ? (
            <MenuSeparator key={item.key} /> 
          ) : (
            item.name === 'Logout' ? (
              <Menu.Item key={item.key} className='menu' onClick={handleLogout}>
                {item.name}
              </Menu.Item>
            ) : (
              <Menu.Item key={item.key} className='menu'>
                <Link to={item.routes} className='menu-item'>{item.name}</Link>
              </Menu.Item>
            )
          )
      ))}
    </Menu>
  );



  const navStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }


  const discounted_percent = 50
  return (
    <nav style={navStyle} className="  shadow-md p-4 w-full top-0 left-0 z-50">
      <div className="container mx-auto flex lg:px-10 px-0 flex-wrap items-center justify-between">

        <div className=' flex justify-around items-center md:w-auto w-full'>

          <Link to="/" className="nav-logo  flex items-center space-x-4">
            <img src={logo} alt="Logo" className="h-16" />
            <h1 className="text-red-800 text-2xl font-bold">n-Bus</h1>
          </Link>
          <Dropdown overlay={MobMenu} trigger={['hover']} className="md:hidden flex itme-center">
            <Button className="flex items-center space-x-2">
              <MenuOutlined className="text-xl text-gray-600" />
              <span className="text-gray-800">Menu</span>
              <DownOutlined />
            </Button>
          </Dropdown>
        </div>

        <div className="hidden md:flex lg:flex items-center space-x-4">
          <Link to="/">
            <img src={busTicket} alt="Bus Ticket" className="h-12" />
          </Link>
          <Link to="/train">
            <Badge
              className="border border-black rounded-lg bg-gray-100"
              style={{ background: 'green', color: 'white' }}
              count={`${discounted_percent}% off`}
            >
              <img src={trainTicket} alt="Train Ticket" className="h-12" />
            </Badge>
          </Link>
        </div>
        <div className="hidden md:flex lg:flex items-center space-x-6">
          <div className="flex items-center space-x-4">
            <CustomerServiceFilled className="text-xl text-gray-600" />
            <Link to="/faq" className="text-gray-600 hover:text-red-600">HELP</Link>
          </div>
          <Dropdown overlay={menu} trigger={['hover']}>
            <Button className="flex items-center space-x-2">
              <UserOutlined className="text-xl text-gray-600" />
              <span className="text-gray-800">My Account</span>
              <DownOutlined />
            </Button>
          </Dropdown>
        </div>
        {/* <button className="lg:hidden flex items-center text-gray-800">
        </button> */}


      </div>
    </nav>
  )
}

export default Mynav